import React from "react"

import { InternalError, BadRequest } from "pages/static"
import { FetchStatusType } from "types"

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entity: any
  fetchStatus: FetchStatusType
  children(entity: object): React.ReactNode
  renderLoading?: () => React.ReactElement
  renderError?: () => React.ReactElement
}

const LoadableEntity = ({
  entity,
  fetchStatus,
  children,
  renderLoading,
  renderError,
}: Props) => {
  if (fetchStatus.isFetching) {
    if (renderLoading) {
      return renderLoading()
    } else {
      return <></>
    }
  }

  if (fetchStatus.isFailed) {
    if (renderError) {
      return renderError()
    } else {
      return <InternalError />
    }
  }

  if (fetchStatus.isSuccess && entity) {
    return <>{children(entity)}</>
  } else if (renderError) {
    return renderError()
  } else {
    return <BadRequest />
  }
}

export default LoadableEntity

/*
Usage:

<LoadableEntity entity={someObject}>
  <SomeObjectView />
</LoadableEntity>

or

<LoadableEntity
  entity={someObject}
  renderLoading={() => <LoadingComponent />}
  renderError={() => <NotFoundComponent />}
>
  {
    (client) =>
      <WrappedComponent
        {...props}
        someObject={someObject}
      />
  }
</LoadableEntity>
*/
